const DOTS = [
  ["2%", "18%", "#FFC20E", 10, 0], ["5%", "62%", "#149B9E", 7, -4], ["9%", "86%", "#FFC20E", 6, -9], ["78%", "12%", "#149B9E", 8, -2],
  ["84%", "74%", "#FFC20E", 9, -6], ["91%", "30%", "#149B9E", 6, -11], ["96%", "60%", "#FFC20E", 7, -3], ["88%", "48%", "#111111", 5, -7],
];

export const FloatingDots = () => (
  <div aria-hidden data-testid="contact-dots" className="pointer-events-none absolute inset-0 -z-[1] hidden lg:block">
    {DOTS.map(([l, t, c, s, d], i) => <span key={i} className="contact-dot" style={{ left: l, top: t, width: s, height: s, background: c, animationDelay: `${d}s` }} />)}
  </div>
);
